<template>
  <div class="story-page">
    <Story v-if="isMobile" />
    <StoryDesktop v-else />
  </div>
</template>

<script>
import Story from '@/components/story/Story';
import StoryDesktop from '@/components/story/StoryDesktop';

export default {
  components: {
    Story,
    StoryDesktop
  },
  computed: {
    isMobile() {
      // Returns true if the userAgent is a mobile device
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    }
  }
};
</script>

<style scoped>
.story-page {
  user-select: none;
}
</style>
